module.exports = __webpack_public_path__ + "assets/img/roles.c2b135b4.svg";